import type { DbModelTier } from "@/types/db";

export type LiveChatFlagTiers = { model_tiers: DbModelTier[] } | null;

/** Whether a resolved liveChatFlag value grants access to the given user's model tier. */
export function isLiveChatEnabledForTier(value: LiveChatFlagTiers, tier: DbModelTier): boolean {
  return value !== null && value.model_tiers.includes(tier);
}
